// StatusPill — small rounded status badge with semantic tones. The frozen
// status colors (success/danger/warning/info) come from tokens and must not be
// overridden per vertical (Frontend Rules §10). From the prototype m2-status-pill.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './status-pill.css';

export function StatusPill({ tone = 'success', dot = true, className, children, ...rest }) {
  return (
    <span className={cx('status-pill', `status-pill--${tone}`, className)} {...rest}>
      {dot && <span className="status-pill__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

StatusPill.propTypes = {
  tone: PropTypes.oneOf(['success', 'warning', 'danger', 'info', 'neutral', 'purple']),
  /** Show the leading status dot. */
  dot: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default StatusPill;
